var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"w-100 text-center font-weight-bold",attrs:{"id":"tabel-dinamis-title"}},[_c('span',{staticClass:"td-text-blue"},[_vm._v("Tabel ")]),_c('span',{staticClass:"td-text-grey"},[_vm._v("Dinamis")]),_c('span',{staticClass:"ml-2",staticStyle:{"font-size":"0.7rem"}},[_vm._v("Ver. "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }